<template>
    <el-row :gutter="20" class="main_block">
        <div :class="status === 4 || status === 5?'mianContent':'mianContent mianConten2'">
            <div class="unverified" v-if="status === 4">
                <img src="@/assets/images/lawyer/deactivate.png" alt="">
                <p>通过律师认证，即可查看案源</p>
                <div class="btn">
                    <span class="button" @click="toCertification">去认证</span>
                </div>
            </div>
            <div class="unverified" v-else-if="status === 5">
                <img src="@/assets/images/lawyer/deactivate2.png" alt="">
                <p>您的律师认证已被停用</p>
                <p class="gray">如需恢复请咨询客服400-0186-091</p>
            </div>
            <div class="iframe-wrap" v-else>
                <div class="btn-wrap">
                    <span @click="goLawyer">获取案源</span>
                </div>
                <iframe :src="frameSrc" frameborder="0" scrolling="no"></iframe>
            </div>
        </div>
    </el-row>
</template>

<script>
import {getLawyerStatus} from '@/http/modules/lawcase'
import { identification } from "@http/user_center/userInfo";
export default {
    data () {
        return {
            status:'',//律师认证状态
            frameSrc:'',
            authenticationStatus:'',//实名认证状态
        }
    },
    components: {},
    computed: {
        access_token() {
            return this.$store.state.userInfo.userinfo.accessToken
        }
    },
    created() {
        this.init();
    },
    mounted() {
        window.addEventListener('message', function(event) {
            if (event.data.action === 'reload') {
                console.log(event.data.action)
                location.reload(); // 或者其他更新操作
            }
        }, false);
        this.frameSrc=process.env.VUE_APP_LAWCASE+'/userCenter/certificationAudit?access_token='+this.access_token+'&parentIframe=account'
    },
    methods: {
        init(){
            identification({hiddenApproval:true}).then((res) => {
                this.authenticationStatus = res.authenticationStatus;
            }).catch((err) => {
                console.log(err);
            });

            getLawyerStatus().then(res => {
                this.status = res.status;
            }).catch(err => {
                console.log(err)
            })
        },
        toCertification(){
            let sourceType=this.$getlocalStorage("queryData")?.sourceType || this.$getlocalStorage("queryData")?.clientId || 975260;
            // if(this.status===5){
            //     window.open(`${process.env.VUE_APP_LAWCASE}/lawyer?sourceType=${sourceType}&fromSystemForLawyerStatus=account`)
            //     return
            // }
            if([0,1,2,4,7,8,10,11].includes(this.authenticationStatus)){
                window.open(`${process.env.VUE_APP_LAWCASE}/userCenter/authentication?sourceType=${sourceType}`)
                this.$alert('如果您的认证状态已更新，请刷新页面', '提示', {
                    confirmButtonText: '刷新页面',
                    cancelButtonText:'取消',
                    showCancelButton:true
                }).then(()=>{
                    location.reload()
                }).catch(()=>{
                    location.reload()
                });
            }else{
                let that=this
                // window.open(`${process.env.VUE_APP_LAWCASE}/lawyer?sourceType=${sourceType}&fromSystemForIdentification=account`)
                this.$alert('认证律师前需要先进行实名认证', '提示', {
                    confirmButtonText: '去实名',
                    cancelButtonText:'取消',
                    showCancelButton:true
                }).then(()=>{
                    window.open('/userCenter/AuthenticationName/Individual');
                    that.$alert('如果您的认证状态已更新，请刷新页面', '提示', {
                        confirmButtonText: '刷新页面',
                        cancelButtonText:'取消',
                        showCancelButton:true
                    }).then(()=>{
                        location.reload()
                    }).catch(()=>{
                        location.reload()
                    });
                }).catch(()=>{
                    // location.reload()
                });
            }
        },
        goLawyer(){
            let sourceType=this.$getlocalStorage("queryData")?.sourceType || this.$getlocalStorage("queryData")?.clientId || 975260;
            window.open(`${process.env.VUE_APP_LAWCASE}/lawyer?sourceType=${sourceType}`)
        }
    },
}

</script>
<style scoped lang='less'>
.mianConten2{
    padding:0;
}
.unverified{
    padding-top: 50px;
    text-align: center;
    img{
        width: 100px;
        height: 100px;
    }
    p{
        padding: 28px 0 19px;
        color: #15161F;
        font-size: 24px;
        font-weight: bold;
        &.gray{
            padding: 0;
            font-weight: 400;
            color:#999;
            font-size: 20px;
        }
    }
    .btn{
        display: flex;
        justify-content: center;
        .button{
            background: #0047FF;
            display: block;
            cursor: pointer;
            color: #fff;
            width: 155px;
            height: 45px;
            text-align: center;
            line-height: 45px;
            font-size: 16px;
            border-radius: 23px;
        }
    }
    
}
.iframe-wrap{
    width: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    background: #F7F8FA;
    .btn-wrap{
        box-sizing: border-box;
        padding:30px 16px 0;
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: flex-end;
        span{
            display: block;
            width: 100px;
            height: 46px;
            border-radius: 23px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size:16px;
            background: #0047FF;
            cursor: pointer;
            position:absolute;
            top:40px;
            right: 16px;
        }
    }
    
    iframe{
        min-width: 1101px;
        width: 100%;
        flex: 1;
    }
}
</style>